import { readable } from "svelte/store";
export const settings = readable(window.FarmcompStore || {});
